// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { LDFlagName } from '../config/launchDarklyFlags';
import { useFeatureFlag } from './useFeatureFlag';
import { useFlagsReady } from './useFlagsReady';

/**
 * Whether to show a flagged surface: the flag is explicitly on **and** its
 * value is LaunchDarkly's real answer for this identity. Every show/hide
 * decision in a component reads this; routes use `FlagRoute`.
 *
 * Off while flags load, so nothing flashes in and out; off when the flag is
 * absent, non-boolean or LaunchDarkly is unconfigured (the catalog default).
 */
export function useFlagOn(name: LDFlagName): boolean {
  const ready = useFlagsReady();
  const on = useFeatureFlag(name);
  return ready && on;
}
